// extracted by mini-css-extract-plugin
module.exports =  {"dialogContent":"dialogContent_tvXfTwNA","orderedList":"orderedList_jAgDFNtn","dialogWarning":"dialogWarning_IVckOf1Q"};